export default class Mounter {
  public get right(): HTMLElement | null {
    return this.rightEl;
  }

  public get center(): HTMLElement {
    return this.centerEl;
  }
  private readonly rightEl: HTMLElement | null;
  private readonly centerEl: HTMLElement;
  constructor() {
    this.rightEl = document.getElementById('RightColId');
    const center = document.getElementById('center-col');
    if (center == null) {
      throw new Error('Center Col needs to exist!');
    }
    this.centerEl = center;
  }
  public sidebarExists() {
    return this.rightEl != null;
  }
  public isAmazonRight() {
    if (this.rightEl == null) {
      return false;
    }
    return this.rightEl.offsetHeight + 400 <= this.centerEl.offsetHeight;
  }

  public doubleWidget() {
    return this.centerEl.offsetHeight > 1000;
  }

  public isValid() {
    return (this.centerEl != null)
  }
}